export default __webpack_public_path__ + "static/media/a020-it-1.51776aa0.svg";